<template>
  <div>
    <main-header></main-header>
    <gDocsSheetStudents/>
    <Footer></Footer>
  </div>
</template>
<script>
// @ is an alias to /src
import gDocsSheetStudents from '@/components/gDocsSheetStudents'
import header from '@/components/landing/mainHeader'
import Footer from '@/components/landing/mainFooter'

export default {
  name: 'Students',
  components: {
    gDocsSheetStudents,
    'main-header': header,
    Footer
  }
}
</script>
